<script lang="ts">
import { defineComponent, defineAsyncComponent, PropType, computed } from 'vue'

const variantModules = import.meta.glob('./split/**/*.vue')

export default defineComponent({
  name: 'SplitComponent',

  inheritAttrs: false,

  props: {
    pattern: {
      type: String,
      default: '',
    },
    field: {
      type: String as PropType<'introduction' | 'profileHeadingLabel' | 'thumbImage'>,
      required: true,
    },
    documentId: {
      type: [String, Number],
      required: true,
    },
  },

  setup(props) {
    const variantComponent = computed(() => {
      if (!props.pattern || !props.field || !props.documentId) return null

      const path = `./split/${props.field}/${props.documentId}_${props.pattern.toLowerCase()}.vue`
      const loader = variantModules[path]

      if (!loader) return null

      return defineAsyncComponent(loader as () => Promise<any>)
    })

    return { variantComponent }
  },
})
</script>

<template>
  <component
    :is="variantComponent"
    v-if="variantComponent"
    v-bind="$attrs" />
  <slot v-else />
</template>
